import Base from './Base'
import styles from './CodeItemsSkeleton.module.css'

export default function CodeItemsSkeleton() {
  return (
    <div data-testid="code-items-skeleton" className={styles.container}>
      <Base className={styles.header} />
      <div className={styles.grid}>
        <CodeItem widths={[431, 309]} />
        <CodeItem widths={[475, 457]} />
        <CodeItem widths={[423, 480]} />
      </div>
    </div>
  )
}

function CodeItem({widths}: {widths: [number, number]}) {
  return (
    <div>
      <div className={styles.itemHeader}>
        <Base className={styles.itemIcon} />
        <Base className={styles.itemTitle} style={{maxWidth: widths[0]}} />
      </div>
      <Base className={styles.itemBody} />
      <div className={styles.itemFooterRow}>
        <Base className={styles.itemFooter} style={{maxWidth: widths[1]}} />
      </div>
    </div>
  )
}
